export const Endpoints = {
  getCsrfToken: 'csrf_token/',
  postLogin: 'login/',
  postAlternativeSso: 'sso/alternative/',
  getUser: 'user/',
  postPasswordReset: 'password-reset/',
  getResetPasswordKey: 'password-reset-check/',
  postConfirmReset: 'password-reset-confirm/',
  postChangePassword: 'password/change/',
  logout: 'logout/',
  getFooterData: 'controls/site_footer_data/',
  getFeesAndTaxesData: 'controls/general_controls/',
  getSubventionYearData: 'controls/loan_terms/',
  getInterestRateList: 'controls/interest_rate/',
  getAdjustEventMessages: 'controls/internal_event_messages/adjust/',
  getVehicleMakes: 'vehicles/makes/',
  getVehicleModels: 'vehicles/models_by_makes/',
  getVehicleBodyTypes: 'vehicles/body_types/',
  getVehiclePhotos: 'vehicles/photos/',
  vehicleAdjustRetail: 'vehicles/adjust/retail/',
  getVehicleAdjustLog: 'vehicles/adjustment-log/',
  getDealers: 'dealers/dealers/',
  getRouteOneDealers: 'dealers/route_one_dealers/',
  getDealersStore: 'dealers/stores/',
  getAllowedDealers: 'dealers/allowed_dealers/',
  getDealersWithManagers: 'dealers/dealers-with-managers/',
  postCreditInterviewInfo: 'consumer/link/send/',
  postUnlockInventory: 'consumer/unlock_inventory/',
  getVehicleBodies: 'vehicles/bodies/',
  getVehicles: 'vehicles/retail/',
  getVehiclesCount: 'vehicles/retail/count/',
  postPrintReport: 'report/',
  sendSearch: 'report/send-search/',
  getControlNumbers: 'controls/number/',
  getControlImages: 'controls/image/',
  getRouteOneMaintenance: 'controls/route_one_maintenance/',
  getFeaturesList: 'features-list/',
  getRACVehicle: 'rac/retail/rac/',
  getRACVehicleByStock: 'rac/retail/rac/used/stock_mode/',
  getTierOptions: 'rac/retail/rac/loan_terms/',
  verification: 'verification-confirm/',
  getLoanVariablesInfo: 'rac/retail/rac/used/loanvariables/',
  getLendersList: 'lenders/lenders/',
  getLender: 'lenders/lender/',
  getLenderVehicles: 'lenders/search_vehicles/',
  getLenderVehiclesByStock: 'lenders/search_vehicles/used/stock_mode/',
  getLenderControls: 'lenders/lender_controls/',
  getLenderLoanVariablesInfo: 'lenders/loanvariables/',
  getLenderLoanTermsList: 'lenders/loan_terms/',
  getLenderVehicleMaxMileage: 'lenders/max_mileage/',
  getUserLenderSettings: 'lenders/user_lender_settings/',
  getDefaultVehiclePhoto: 'vehicles/default_photo/',
  getPassengerCapacities: 'vehicles/passenger_capacities/',
  getLoanTermsList: 'rac/retail/rac/loan_terms_list/',
  dealSourceData: 'vehicles/credit_decision/',
  getRegionControls: 'region/region_controls/',
  getStateRegions: 'region/state_regions/',
  postJDPUsage: 'rac/retail/rac/jdp_usage/',
  getRateSheetsData: 'rac/retail/rac/rate_sheets_data/',
  createUserVehicle: 'vehicles/create_user_vehicle/',
  deleteUserVehicle: 'vehicles/delete_user_vehicle/',
  updateUserVehicle: 'vehicles/update_user_vehicle/',
  balloonMaxOdometers: 'vehicles/balloon_max_odometers/',
  balloonVehicleInfo: 'vehicles/balloon_vehicle_info/',
  balloonVehicleEngines: 'vehicles/balloon_vehicle_engines/',
  balloonResidualValues: 'vehicles/balloon_residual_values/',
  balloonQuote: 'vehicles/balloon_quote/',
  balloonDealQuote: 'vehicles/balloon_deal_quote/',
  downloadBalloonAddendum: 'vehicles/download_balloon_addendum/',
  balloonDaysToFirstPayment: 'vehicles/balloon_days_to_first_payment/',
  getAIVinDecodedData: 'vehicles/ai_vin_decode/',
  snowflakeImport: 'vehicles/foureyes_import/',
  inventoryImportStatus: 'vehicles/task_status/',
  gamificationTrack: 'gamification/track/',
  gamificationAchievements: 'gamification/achievements/',
  gamificationSummary: 'gamification/summary/',
};
